import React from 'react'
import { Tooltip } from '@mantine/core'

const QuizTooltip = ({
    children,
    label,
}: {
    children: React.ReactNode
    label?: string
}) => {
    return (
        <Tooltip label={label} position='top-end' withArrow withinPortal>
            {children}
        </Tooltip>
    )
}

export default QuizTooltip
